var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWsGo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20311 -1963)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-20311 1963)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16308.202 -3119.613)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3996.526 5088.884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3974.053,5110.237c-.225-.012-16.875-.037-18.576-.033-.328,0-.329-.207-.329-.437q0-1.729,0-3.456v-5.7c0-2.989.009-5.978-.009-8.967,0-.455.1-.616.591-.614q7.589.029,15.178,0c.422,0,.565.109.564.544q-.01,4.85-.005,9.7h2.087q0-4.764-.012-9.527c0-.507.1-.729.646-.8a.991.991,0,0,0,.741-1.453c-.264-.557-.764-.621-1.3-.62q-10.295,0-20.59,0c-.108,0-.218,0-.327,0a1.078,1.078,0,0,0-1.127,1.016,1,1,0,0,0,.979,1.085c.448.047.5.25.5.628q-.014,9.012-.006,18.023v.533c-.153.017-.214.025-.274.03-.771.062-1.21.462-1.2,1.094.01.68.452,1.044,1.27,1.044q10.483,0,20.965,0c.722,0,1.149-.342,1.213-.96A1.034,1.034,0,0,0-3974.053,5110.237Z",
    transform: "translate(3996.525 -5088.883)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3861.2,5186.081c-1.392,0-1.392,0-1.392-1.385,0-.217,0-.435,0-.652.006-.593.224-.822.8-.831.435-.007.87-.013,1.3,0a.672.672,0,0,1,.741.756c.01.466.009.932,0,1.4a.635.635,0,0,1-.715.714C-3860.7,5186.085-3860.948,5186.082-3861.2,5186.081Z",
    transform: "translate(3875.1 -5174.394)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3908.478,5186.134c-1.441,0-1.441,0-1.441-1.425,0-1.444,0-1.444,1.449-1.444,1.4,0,1.419.034,1.436,1.428C-3907.016,5186.19-3907.165,5186.174-3908.478,5186.134Z",
    transform: "translate(3918.01 -5174.447)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3908.526,5139.268c-1.428,0-1.418,0-1.43-1.419-.011-1.514.077-1.44,1.4-1.418.249,0,.5,0,.745,0,.486,0,.711.205.733.7.021.448.016.9,0,1.349-.014.568-.229.775-.8.789C-3908.091,5139.271-3908.309,5139.268-3908.526,5139.268Z",
    transform: "translate(3918.044 -5131.982)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3861.226,5136.5h.464c.9,0,1,.1,1,1.021,0,.372.009.745,0,1.116a.624.624,0,0,1-.692.7c-.48.014-.961.013-1.442,0a.634.634,0,0,1-.713-.719c-.007-.465,0-.932,0-1.4.006-.535.188-.709.737-.717C-3861.661,5136.5-3861.443,5136.5-3861.226,5136.5Z",
    transform: "translate(3875.128 -5132.051)",
    fill: "currentColor",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3982.839 5101.654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3850.01,5228.711a7.673,7.673,0,0,1,.094-1.042,1.018,1.018,0,0,1,1.029-.8c.391-.006.783,0,1.174,0s.38,0,.381-.368c0-.223,0-.448,0-.67a1.075,1.075,0,0,1,.687-1.029,1.066,1.066,0,0,1,1.212.243q1.4,1.252,2.79,2.513c.208.187.413.376.619.564a.743.743,0,0,1,0,1.2c-.766.7-1.54,1.386-2.309,2.081-.368.331-.734.663-1.1.993a1.1,1.1,0,0,1-1.869-.5,5.44,5.44,0,0,1-.037-.929c-.005-.369,0-.368-.363-.37-.4,0-.8.012-1.2-.01a1.092,1.092,0,0,1-1.091-1.131c-.009-.247,0-.494,0-.741A.167.167,0,0,1-3850.01,5228.711Z",
    transform: "translate(3850.01 -5224.704)",
    fill: "currentColor",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWsGo);
export default __webpack_public_path__ + "static/media/icon-ws-go.140ab904.svg";
export { ForwardRef as ReactComponent };